export const panelTrackingIdByHeaderPresetSelect = {
  id: 'root',
  data: {
    panelTrackingId: {
      values: [
        {
          provider: 'id:root',
          property: 'hasPresetSelectHeader',
        },
        {
          provider: 'id:preselect-header-select',
          property: 'toggleFilter',
          startWith: ['0'],
        },
      ],
      transform: function ([hasPresetSelectHeader, selectedHeaderPreset]: [
        boolean,
        string,
      ]) {
        if (hasPresetSelectHeader && selectedHeaderPreset?.[0] === '1') {
          return '2HPA';
        }
        return '2HPAGT';
      }.toString(),
    },
  },
};
